import { TaskService } from "../services/taskService";

export interface UserCredentials {
  email: string;
  password: string;
}

export enum UserType {
  WORKER = 'worker',
  REQUESTER = 'requester',
  ADMIN = 'admin'
}

export interface AuthResponse {
  token: string;
  refresh_token?: string;
  user_type: UserType;
  user_id: string;
  expires_in?: string | number;
  max_session_duration?: number;
  inactivity_timeout?: number;
  warning_period?: number;
}

export const ROUTES = {
  HOME: '/',
  WORKER_DASHBOARD: '/data_reviewer_dashboard',
  REQUESTER_DASHBOARD: '/requester_dashboard',
  ADMIN_DASHBOARD: '/dashboard'
} as const;

export interface AuthContextType {
  isAuthenticated: boolean;
  userType: UserType | null;
  isLoading: boolean;
  taskService: TaskService;
  login: (credentials: UserCredentials) => Promise<AuthResponse>;
  logout: () => void;
  register: (userData: UserCredentials & { full_name: string; user_type: UserType; invite_code?: string }) => Promise<void>;
  refreshSession: () => Promise<boolean>;
  // Debug method to manually trigger session warning
  debugTriggerSessionWarning?: () => void;
}
